import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_JOB_FOLDERS_LOG: TDatadogErrorLog = {
  from: 'src/components/JobFolderSelectorList/JobFolderSelectorList.jsx',
  name: 'Get Jobs Folders',
  message: 'Fetch list of folders for a dashboard',
}
